// THE NUCLEUS MARK — the double lotus: string art in one ink, the way the
// fleet's figures are made (Synapse's hummingbird): straight threads at part
// opacity, a nail at their ends, every curve the envelope of the threads.
//
//   the identity  a double lotus: eight stitched petals and, between them,
//                 eight shorter ones. Each side of a petal is a stitched
//                 corner (base → side → tip), so its edges bow
//   the world     a ring of nails threaded as a star {60/22}; its threads'
//                 inner envelope is the circle that holds the lotus
//
// Drawn identity first, so the splash draws it in from the centre outward.
// Three densities of the same figure, so it reads at every size: the whole
// figure (splash, dock tile), the seat (the rail, about 34px) and the tab
// (16px). Markup is the kit's string-art contract (DrawnMark): <line>s and
// nails in currentColor, their weight and opacity inline.

const C = 100;
const f = (v) => v.toFixed(2);
const polar = (r, deg) => [C + r * Math.cos(((deg - 90) * Math.PI) / 180), C + r * Math.sin(((deg - 90) * Math.PI) / 180)];
const lerp = (a, b, t) => [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
const thread = (a, b, w, o) => `<line x1="${f(a[0])}" y1="${f(a[1])}" x2="${f(b[0])}" y2="${f(b[1])}" style="stroke-width:${w}" opacity="${o}"></line>`;
const nail = (p, r, o = 0.85) => `<circle cx="${f(p[0])}" cy="${f(p[1])}" r="${r}" fill="currentColor" stroke="none" opacity="${o}"></circle>`;

// one petal: base B, tip T, its sides bowing out through two points either
// side of its middle; each side stitched as a corner, so the edges curve
function petal(B, T, width, n, w, o, nailR) {
    const mid = lerp(B, T, 0.45);
    const len = Math.hypot(T[0] - B[0], T[1] - B[1]);
    const nx = (-(T[1] - B[1]) / len) * width;
    const ny = ((T[0] - B[0]) / len) * width;
    let s = '';
    const pins = [];
    [[mid[0] + nx, mid[1] + ny], [mid[0] - nx, mid[1] - ny]].forEach((S) => {
        for (let i = 0; i <= n; i += 1) {
            const p = lerp(B, S, i / n);
            const q = lerp(S, T, i / n);
            s += thread(p, q, w, o);
            if (i % 2 === 0) pins.push(p, q);
        }
    });
    return s + (nailR ? pins.map((p) => nail(p, nailR)).join('') : '');
}
const flower = (k, r0, r1, width, n, w, o, nailR, turn = 0) => Array.from({ length: k }, (_, i) => {
    const a = (i / k) * 360 + turn;
    return petal(polar(r0, a), polar(r1, a), width, n, w, o, nailR);
}).join('');

// a ring of nails threaded as a star {n/k}
function starRing(r, n, k, w, o, nailR) {
    const P = (i) => polar(r, (i / n) * 360);
    let s = '';
    for (let i = 0; i < n; i += 1) s += thread(P(i), P(i + k), w, o);
    return s + Array.from({ length: n }, (_, i) => nail(P(i), nailR)).join('');
}

const svg = (body, pad) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${pad} ${pad} ${200 - 2 * pad} ${200 - 2 * pad}" width="100%" height="100%" fill="none" stroke="currentColor" stroke-linecap="round">${body}</svg>`;

export const NUCLEUS_SVG = svg(
    flower(8, 3, 32, 7, 9, 0.4, 0.8, 0.5) + flower(8, 3, 20, 5, 7, 0.35, 0.6, 0.45, 22.5) + starRing(80, 60, 22, 0.3, 0.45, 0.55),
    16,
);
export const NUCLEUS_SEAT_SVG = svg(
    flower(8, 3, 34, 8, 3, 1.5, 1, 0) + flower(8, 3, 21, 5, 2, 1.1, 0.7, 0, 22.5) + starRing(82, 24, 9, 1.1, 0.55, 1.8),
    14,
);
export const NUCLEUS_TAB_SVG = svg(
    flower(8, 2, 36, 9, 2, 3.4, 1, 0) + starRing(84, 12, 4, 3.4, 0.8, 0),
    10,
);

// the figure for a size
export const nucleusFigure = (size) => (size >= 64 ? NUCLEUS_SVG : size >= 24 ? NUCLEUS_SEAT_SVG : NUCLEUS_TAB_SVG);
